import React from 'react';
import { useWizard, WizardStep } from '@zillow/zrs-rental-applications';

interface RenderStepProps {
  id: string;
  label: string;
  hidden?: boolean;
  render: () => React.ReactElement;
}

// Avoiding rendering the actual component until necessary. This avoids hooks being fired off before the step is being rendered
export default function RenderStep({ id, label, hidden = false, render }: RenderStepProps) {
  const { currentStep } = useWizard();
  if (currentStep !== id) {
    return <WizardStep id={id} label={label} hidden={hidden} render={() => null} />;
  }
  return render();
}
